// Mock Data für Gemeinschaftspraxis Dres. von Bergh
// Echte Bilder aus den hochgeladenen Assets

// Hero Videos (YouTube)
export const heroVideos = [
  { id: 1, url: 'https://www.youtube.com/embed/zVoRxYWi6A0', title: 'Praxis Video 1' },
  { id: 2, url: 'https://www.youtube.com/embed/LjNlB8xOWS8', title: 'Praxis Video 2' },
  { id: 3, url: 'https://www.youtube.com/embed/qd_SFDFBovw', title: 'Praxis Video 3' },
  { id: 4, url: 'https://www.youtube.com/embed/7UR1Mlh9-C4', title: 'Praxis Video 4' },
  { id: 5, url: 'https://www.youtube.com/embed/hAekK0h3sRY', title: 'Praxis Video 5' },
  { id: 6, url: 'https://www.youtube.com/embed/mrVhuJUpet8', title: 'Praxis Video 6' },
  { id: 7, url: 'https://www.youtube.com/embed/xjf6t_K8-Bw', title: 'Praxis Video 7' },
  { id: 8, url: 'https://www.youtube.com/embed/EK9H90xXMFY', title: 'Praxis Video 8' },
  { id: 9, url: 'https://www.youtube.com/embed/e1lrdh1OA7A', title: 'Praxis Video 9' }
];

// Hero Slider Bilder (Fallback wenn kein Video)
export const heroSliderImages = [
  { id: 1, url: '/images/Hero_Startseite_Empfang_opt.webp', alt: 'Medicum Diez Empfang' },
  { id: 2, url: '/images/mrt3.jpg', alt: 'MRT Untersuchung' },
  { id: 3, url: '/images/wartezimmer_neu_opt.webp', alt: 'Wartezimmer' }
];

export const pageHeroImages = {
  leistungen: '/images/2_Leistungen_Hero.webp',
  hausarzt: '/images/2A_Hausarzt_Familie.webp',
  diagnostik: '/images/MRT 5.webp',
  kardiologie: '/images/2C_Hero_Kardiologie.webp',
  vorsorge: '/images/ganze Familie.webp',
  ueberUns: '/images/Konzept.webp',
  team: '/images/TEAM (12).webp',
  kompass: '/images/Content_Behandlung_7.webp',
  medicum: '/images/So_finden_Sie_uns.webp',
  faq: '/images/VB00136648_Kopie.jpg',
  termin: '/images/4_Termin_Beratung.webp',
  dmp: '/images/Content_Behandlung_2.webp',
  schmerz: '/images/2F_Hero_Schmerztherapie.webp',
  spezial: '/images/Behandlung88.webp',
  digital: '/images/4_Termin_Online.webp',
  checkup35: '/images/Checkup35_Hero.webp',
  impressum: '/images/Praxis_Wartezimmer.webp',
  datenschutz: '/images/Content_Behandlung_3.webp'
};

// Feature-Bilder für Cards
export const featureImages = {
  akut: '/images/Content_Behandlung_4.webp',
  sprechstunde: '/images/hausarzt.webp',
  hausbesuche: '/images/Hausbesuche.webp',
  krankschreibung: '/images/Content_Behandlung_5.webp',
  impfungen: '/images/Content_Behandlung_6.webp',
  kindervorsorge: '/images/2A6_Kindervorsorge.webp',
  psychosomatik: '/images/Psychosomatik.webp',
  mrt: '/images/MRT Detail.webp',
  ekg: '/images/Kardiologie.webp',
  belastungsekg: '/images/belastungs_EKG.webp',
  ultraschall: '/images/2B4_Ultraschall_Sonographie.webp',
  lungenfunktion: '/images/LUNGE.webp',
  labor: '/images/Content_Behandlung_8.webp',
  blutdruck: '/images/Content_Behandlung_9.webp',
  hrv: '/images/Hörtest.webp',
  herzcheck: '/images/Kardiologie 2.webp',
  herzultraschall: '/images/Kardiologie 4.webp',
  schlaganfall: '/images/Kardio 6.webp',
  checkup35: '/images/ganze Familie.webp',
  krebsvorsorge: '/images/Content_Behandlung_1.webp',
  hautkrebs: '/images/Hautkrebs.webp',
  darmkrebs: '/images/Darm Untersuchung.webp',
  akupunktur: '/images/2F_Akupunktur.webp',
  wirbelsaeule: '/images/2F_Wirbelsaeule_Behandlung.webp',
  aesthetik: '/images/2G_Botox_Aesthetik.webp',
  sehtest: '/images/2G_Sehtest.webp'
};

export const kontaktDaten = {
  praxisName: 'Gemeinschaftspraxis Dres. von Bergh',
  adresse: {
    strasse: 'Im Werkes 1',
    plz: '65582',
    ort: 'Diez'
  },
  telefon: '06432 / 2236',
  fax: '06432 / 4601',
  email: 'mail@drvonbergh.de'
};

export const sprechzeiten = [
  { tag: 'Montag', zeit: '08:00 – 13:00 Uhr' },
  { tag: 'Dienstag', zeit: '08:00 – 13:00 Uhr & 16:00 – 19:00 Uhr' },
  { tag: 'Mittwoch', zeit: '08:00 – 13:00 Uhr' },
  { tag: 'Donnerstag', zeit: '08:00 – 13:00 Uhr (Nachmittags nach Vereinbarung)' },
  { tag: 'Freitag', zeit: '08:00 – 13:00 Uhr' }
];

export const notfallsprechstunde = [
  { tag: 'Montag', zeit: '08:00 – 11:00 Uhr (Nur Notfälle)' },
  { tag: 'Dienstag bis Freitag', zeit: '08:00 – 09:00 Uhr' }
];

export const aerzte = [
  {
    id: 1,
    name: 'Dr. med. Mischa von Bergh',
    titel: 'Facharzt für Allgemeinmedizin',
    schwerpunkte: ['Hausärztliche Versorgung', 'Kardiologie', 'Präventivmedizin'],
    bild: '/Mischa von Bergh.webp'
  },
  {
    id: 2,
    name: 'Dr. med. Martin von Bergh, MBA',
    titel: 'Facharzt für Allgemeinmedizin, Notfallmedizin',
    schwerpunkte: ['Notfallmedizin', 'Diagnostik', 'Schmerztherapie'],
    bild: '/Martin von Bergh.webp'
  }
];

export const praxisteam = [
  { id: 1, bild: '/3_2_Team_Praxisteam_1.webp' },
  { id: 2, bild: '/3_2_Team_Praxisteam_2.webp' }
];

export const faqData = [
  { frage: 'Wie vereinbare ich am besten einen Termin?', antwort: 'Am einfachsten über unsere Online-Terminbuchung auf der Website oder telefonisch unter 06432 / 2236.' },
  { frage: 'Wann findet die Notfallsprechstunde statt?', antwort: 'Montag 08:00–11:00 Uhr, Dienstag bis Freitag 08:00–09:00 Uhr.' },
  { frage: 'Bieten Sie Hausbesuche an?', antwort: 'Ja, bei medizinischer Notwendigkeit besuchen wir Patienten in Diez und Umgebung auch zu Hause.' },
  { frage: 'Was muss ich zum ersten Termin mitbringen?', antwort: 'Bitte bringen Sie Ihre Versichertenkarte, ggf. einen Medikationsplan und Vorbefunde mit.' },
  { frage: 'Gibt es Parkplätze an der Praxis?', antwort: 'Ja, direkt vor dem Medicum Diez stehen Ihnen ausreichend kostenlose Parkplätze zur Verfügung.' },
  { frage: 'Ist die Praxis barrierefrei?', antwort: 'Ja, alle Räumlichkeiten sind über einen Aufzug barrierefrei erreichbar.' },
  { frage: 'Führen Sie das Hautkrebs-Screening durch?', antwort: 'Ja, wir bieten die visuelle Kontrolle der Haut als wichtige Vorsorgeleistung an.' },
  { frage: 'Was ist ein offenes MRT?', antwort: 'Ein MRT ohne enge Röhre, das besonders für Patienten mit Platzangst sehr komfortabel ist.' },
  { frage: 'Bieten Sie Impfungen für Fernreisen an?', antwort: 'Ja, wir beraten Sie individuell und führen die nötigen Impfungen durch.' },
  { frage: 'Ab welchem Alter ist der Check-up 35 sinnvoll?', antwort: 'Ab dem 35. Lebensjahr alle drei Jahre.' },
  { frage: 'Was ist die Cardisiographie?', antwort: 'Ein innovatives 3D-EKG-Verfahren zur Früherkennung von Herzerkrankungen.' },
  { frage: 'Wie erhalte ich ein Folgerezept?', antwort: 'Rezepte können online oder telefonisch vorbestellt und am Folgetag abgeholt werden.' },
  { frage: 'Behandeln Sie auch Kinder?', antwort: 'Ja, wir führen Kindervorsorgeuntersuchungen und pädiatrische Grundversorgung durch.' },
  { frage: 'Bieten Sie Akupunktur an?', antwort: 'Ja, im Rahmen unserer Schmerztherapie setzen wir Akupunktur gezielt ein.' },
  { frage: 'Was ist das DMP-Programm?', antwort: 'Strukturierte Behandlungsprogramme für chronisch Kranke (z.B. Diabetes, Asthma).' },
  { frage: 'Können MRT-Untersuchungen mit Herzschrittmacher durchgeführt werden?', antwort: 'Ja, oft ist dies unter spezieller kardiologischer Koordination möglich.' },
  { frage: 'Führen Sie Ultraschalluntersuchungen durch?', antwort: 'Ja, für Bauchorgane, Schilddrüse und Gefäße.' },
  { frage: 'Wie erfahre ich meine Laborergebnisse?', antwort: 'Wichtige Befunde besprechen wir persönlich oder telefonisch nach Vereinbarung.' },
  { frage: 'Welche ästhetischen Leistungen bieten Sie an?', antwort: 'Wir beraten Sie gerne zu individuellen Gesundheitsleistungen (IGeL).' },
  { frage: 'Sind Sie auch für Patienten aus Limburg da?', antwort: 'Selbstverständlich, wir versorgen die gesamte Region Diez-Limburg.' }
];

// NEUE NAVIGATION nach Sitemap
export const navigation = [
  { id: '1', label: 'Startseite', path: '/' },
  { 
    id: '2', 
    label: 'Leistungen', 
    path: '/leistungen',
    children: [
      { 
        id: '2A', 
        label: 'Hausärztliche Leistungen', 
        path: '/leistungen/hausarzt',
        children: [
          { id: '2A1', label: 'Akutsprechstunde', path: '/leistungen/hausarzt/akut' },
          { id: '2A2', label: 'Allgemeine Sprechstunde', path: '/leistungen/hausarzt/sprechstunde' },
          { id: '2A3', label: 'Hausbesuche', path: '/leistungen/hausarzt/hausbesuche' },
          { id: '2A4', label: 'Krankschreibungen & eAU', path: '/leistungen/hausarzt/krankschreibung' },
          { id: '2A5', label: 'Impfungen & Impfberatung', path: '/leistungen/hausarzt/impfungen' },
          { id: '2A6', label: 'Kindervorsorge (U3–U10, J1)', path: '/leistungen/hausarzt/kindervorsorge' },
          { id: '2A7', label: 'Psychosomatische Grundversorgung', path: '/leistungen/hausarzt/psychosomatik' }
        ]
      },
      { 
        id: '2B', 
        label: 'Diagnostik-Zentrum', 
        path: '/leistungen/diagnostik',
        children: [
          { id: '2B1', label: 'Offenes MRT', path: '/leistungen/diagnostik/mrt' },
          { id: '2B2', label: 'EKG (Ruhe / Langzeit)', path: '/leistungen/diagnostik/ekg' },
          { id: '2B3', label: 'Belastungs-EKG', path: '/leistungen/diagnostik/belastungs-ekg' },
          { id: '2B4', label: 'Ultraschall (Sonographie)', path: '/leistungen/diagnostik/ultraschall' },
          { id: '2B5', label: 'Lungenfunktion (Spirometrie)', path: '/leistungen/diagnostik/lungenfunktion' },
          { id: '2B6', label: 'Labordiagnostik', path: '/leistungen/diagnostik/labor' },
          { id: '2B7', label: 'Langzeit-Blutdruckmessung', path: '/leistungen/diagnostik/blutdruck' },
          { id: '2B8', label: 'Pulsuhr-Analyse (HRV)', path: '/leistungen/diagnostik/hrv' }
        ]
      },
      { 
        id: '2C', 
        label: 'Kardiologie & Herz-Check', 
        path: '/leistungen/kardiologie',
        children: [
          { id: '2C1', label: 'Herz-Check (Kardiologische Vorsorge)', path: '/leistungen/kardiologie/herz-check' },
          { id: '2C2', label: 'Herz-Ultraschall (Echokardiographie)', path: '/leistungen/kardiologie/ultraschall' },
          { id: '2C3', label: 'Schlaganfall-Vorsorge (Halsschlagader-Check)', path: '/leistungen/kardiologie/schlaganfall' }
        ]
      },
      { 
        id: '2D', 
        label: 'Vorsorge & Prävention', 
        path: '/leistungen/vorsorge',
        children: [
          { id: '2D1', label: 'Check-up 35 (Gesundheitsuntersuchung)', path: '/leistungen/vorsorge/checkup35' },
          { id: '2D2', label: 'Krebsvorsorge (Männer)', path: '/leistungen/vorsorge/krebsvorsorge' },
          { id: '2D3', label: 'Hautkrebs-Screening', path: '/leistungen/vorsorge/hautkrebs' },
          { id: '2D4', label: 'Darmkrebsvorsorge', path: '/leistungen/vorsorge/darmkrebs' }
        ]
      },
      {
        id: 'preventum-diez',
        label: 'Preventum Diez – Prävention & Sportmedizin ↗',
        path: 'https://preventum-diez.de/',
        external: true
      },
      { id: '2E', label: 'DMP – Chronikerprogramme', path: '/leistungen/dmp' },
      { id: '2F', label: 'Schmerz & Wirbelsäule / Akupunktur', path: '/leistungen/schmerz' },
      { id: '2G', label: 'Spezial-Checks & Ästhetik', path: '/leistungen/spezial' },
      { id: '2H', label: 'Patienten-Service & Digitales', path: '/leistungen/digital' }
    ]
  },
  { 
    id: '3', 
    label: 'Über uns', 
    path: '/ueber-uns',
    children: [
      { id: '3.1', label: 'Unser Kompass', path: '/ueber-uns/kompass' },
      { id: '3.2', label: 'Das Team', path: '/ueber-uns/team' },
      { id: '3.3', label: 'Das Medicum-Konzept', path: '/ueber-uns/medicum' },
      { id: '3.4', label: 'Leistungen & Fragen (FAQ)', path: '/ueber-uns/faq' }
    ]
  },
  { id: '4', label: 'Kontakt & Anfahrt', path: '/termin' }
];
